import React from 'react'
import { Redirect } from 'react-router-dom'
import { Container, Panel, FormPanel, Spacer } from '@sencha/ext-modern'
import { addListItem, changeListItem, deleteListItem, getFormValue, getListItems, hasChangedValues } from 'Tyan/public/utility'
import Form from 'Tyan/public/components/Form'
import Logo from './Logo'
import colors from 'Tyan/components/colors'
import SupplierContactWrite from './SupplierContactWrite'
import SupplierMainInstrumentWrite from './SupplierMainInstrumentWrite'
import SupplierYearTurnoverWrite from './SupplierYearTurnoverWrite'
import SupplierMainCustomerWrite from './SupplierMainCustomerWrite'
import Message from 'Tyan/public/components/Message'


const panelProps = {
    height: "100%",
    margin: '0 0 40 0',
}

class SupplierInformationWrite extends React.Component {
    state = { initValues: {}, changedValues: {} }
    componentDidMount = () => {
        this.handlerInitValue()
    }

    handlerInitValue = () => {
        const { match: { params: { token } } } = this.props
        Tyan.doPostEvent({
            event: 'GetSupplierByEmail',
            data: { token },
            onEnd: ({ errorMessage, initValues基本信息, initValues联系人, initValues主要客户, initValues年营业额, initValues主要设备, optionsParas }) => {
                if (errorMessage) {
                    window.alert(errorMessage)
                    this.closeWindows()
                    return
                }
                this.setState({ optionsParas, initValues联系人, initValues主要客户, initValues年营业额, initValues主要设备, initValues基本信息, changedValues基本信息: {} })
            }
        })
    }

    handlerAddContact = () => {
        const { list } = getListItems(this, '联系人', '联系人')
        Tyan.pubForm.showDialog('联系人', props => <SupplierContactWrite {...props}
            initValues基本信息={{}}
            onConfirm={(changedValues, typesOfchangedValues, onClose) => {
                let { 姓名 } = changedValues
                if (姓名) {
                    姓名 = 姓名.replace(/(^\s*)|(\s*$)/g, "")
                    if (姓名 == '') {
                        Tyan.pubForm.showError('联系人姓名不为空，请确认！')
                        return
                    }
                    if (list.filter(o => 姓名 == o.姓名).length) {
                        Tyan.pubForm.showError('联系人姓名重复，请确认！')
                        return
                    }
                    addListItem(this, { ...changedValues }, '联系人', '联系人')
                    onClose && onClose()
                }
            }}
        />)
    }

    handlerAddMainInstrument = () => {
        Tyan.pubForm.showDialog('主要生产/检测设备', props => <SupplierMainInstrumentWrite {...props}
            initValues基本信息={{}}
            onConfirm={(changedValues, typesOfchangedValues, onClose) => {
                addListItem(this, { ...changedValues }, '主要设备', '主要设备')
                onClose && onClose()
            }}
        />)
    }

    handlerAddYearTurnover = () => {
        const { list } = getListItems(this, '年营业额', '年营业额')
        Tyan.pubForm.showDialog('年营业额', props => <SupplierYearTurnoverWrite {...props}
            initValues基本信息={{}}
            onConfirm={(changedValues, typesOfchangedValues, onClose) => {
                let { 年份 } = changedValues
                if (年份) {
                    年份 = 年份.replace(/(^\s*)|(\s*$)/g, "")
                    if (年份 == '') {
                        Tyan.pubForm.showError('年营业额年份不为空，请确认！')
                        return
                    }
                    if (list.filter(o => 年份 == o.年份).length) {
                        Tyan.pubForm.showError('年营业额年份重复，请确认！')
                        return
                    }
                    addListItem(this, { ...changedValues }, '年营业额', '年营业额')
                    onClose && onClose()
                }
            }}
        />)
    }

    handlerAddMainCustomer = () => {
        const { list } = getListItems(this, '主要客户', '主要客户')
        Tyan.pubForm.showDialog('主要客户', props => <SupplierMainCustomerWrite {...props}
            initValues基本信息={{}}
            onConfirm={(changedValues, typesOfchangedValues, onClose) => {
                let { 公司名称, 年度 } = changedValues
                if (年度 && 公司名称) {
                    公司名称 = 公司名称.replace(/(^\s*)|(\s*$)/g, "")
                    if (公司名称 == '') {
                        Tyan.pubForm.showError('主要客户公司名称不为空，请确认！')
                        return
                    }
                    年度 = 年度.replace(/(^\s*)|(\s*$)/g, "")
                    if (年度 == '') {
                        Tyan.pubForm.showError('年营业额年度不为空，请确认！')
                        return
                    }
                    if (list.filter(o => 公司名称 == o.公司名称 && 年度 == o.年度).length) {
                        Tyan.pubForm.showError('主要客户公司名称与重复，请确认！')
                        return
                    }
                    addListItem(this, { ...changedValues }, '主要客户', '主要客户')
                    onClose && onClose()
                }
            }}
        />)
    }

    handleSubmit = () => {
        const { match: { params: { token } } } = this.props
        const { changedValues基本信息, changedValues联系人, changedValues年营业额, changedValues主要客户, changedValues主要设备 } = this.state
        const 供应商名称 = getFormValue(this, '基本信息', '供应商名称')
        if (!供应商名称) { Ext.toast("供应商名称不能为空！"); return }
        Tyan.doPostEvent({
            event: 'SaveSupplierByEmail',
            data: {
                token, changedValues基本信息, changedValues联系人,
                changedValues年营业额, changedValues主要客户, changedValues主要设备
            },
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                window.alert('保存成功。')
                this.closeWindows()
            }
        })
    }

    closeWindows = () => {
        window.opener = null
        window.open('about:blank', '_self')
        window.close()
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    fieldset供应商信息 = () => {
        const { optionsParas = {} } = this.state
        return [
            { _text: '供应商编号/<br>Supplier Number', name: '供应商编号', minWidth: '45%' },
            { _text: '供应商名称/<br>Supplier Name', name: '供应商名称', minWidth: '45%', required: true },
            { _text: '统一社会信用代码/<br>Unified Social Credit Code', name: '统一社会信用代码', minWidth: '45%' },
            //{ _float: '成交总额', minWidth: '45%' },
            { _text: '公司地址/<br>Company Address', name: '公司地址', minWidth: '45%' },
            { _text: '公司负责人/<br>Company legal person', name: '公司负责人', minWidth: '45%' },
            { _text: '公司电话/<br>Company Tel', name: '公司电话', minWidth: '45%' },
            { _date: '公司成立日期/<br>Company Starting Date', name: '公司成立日期', minWidth: '45%' },
            { _text: '注册资本金/<br>Registered Capital', name: '注册资本金', minWidth: '50%' },
            { _int: '员工人数/<br>Headcount', name: '员工人数', minWidth: '20%' },
            { _int: '其中技术人员/<br>One of the technicians', name: '技术人员', minWidth: '20%', },
            { _radio: '公司类型/<br>Tax of enterprise', name: '公司类型', minWidth: '45%', items: optionsParas.公司类型, },
            { _select: '付费条件/<br>Term of payment', name: '付款方式', minWidth: '45%', options: optionsParas.付款方式 },
            { _text: '银行开户名称/<br>Foreign capital', name: '银行开户名称', minWidth: '45%' },
            { _text: '银行帐号/<br>Bank account numbers', name: '银行帐号', minWidth: '45%' },
            { _text: '开户银行/<br>Name of Bank', name: '开户银行', minWidth: '45%' },
            { _select: '采购经办人/<br>Purchasing contact person', name: '采购经办人', minWidth: '45%', options: optionsParas.采购经办人, disabled:true },
            // { _text: '银行地址', minWidth: '45%' },
            { _select: '发票税率/<br>Tax Rate', name: '发票税率', minWidth: '45%', options: optionsParas.发票税率 },
            { _select: '发票种类/<br>Invoice category', name: '发票种类', minWidth: '45%', options: optionsParas.发票种类 },
            // { _select: '经营类别', minWidth: '45%', options: optionsParas.经营类别 },
            { _select: '税分类/<br>Tax classification', name: '税分类', minWidth: '45%', options: optionsParas.税分类 },
            //{ _select: '会计分类/<br>Accounting classification', name: '会计分类', minWidth: '45%', options: optionsParas.会计分类 },
            { _checkbox: '公司资质/<br>Company qualification', name: '公司资质', minWidth: '95%' },
            { _radio: '信息安全保密制度/<br>Information security system', name: '信息安全保密制度', minWidth: '45%', items: optionsParas.信息安全保密制度 },
            { _radio: '近三年客户信息泄露事件/<br>Costomer information disclosure in the past three years', name: '近三年客户信息泄露事件', minWidth: '45%', items: optionsParas.近三年客户信息泄露事件 },
            { _select: '交易币别/<br>Transaction currency', name: '交易币别', minWidth: '45%', options: optionsParas.交易币别 },
            { _text: 'Switf code', name: 'SwitfCode', minWidth: '45%' },
            //{ _select: '分类/<br>Classification', name: '分类', minWidth: '45%', options: optionsParas.分类 },
            { _text: '经营范围/<br>Nature of Business', name: '经营范围', minWidth: '95%', maxRows: 3 },
            { _text: '关联公司及关系/<br>Related companies and relationships', name: '关联公司及关系', minWidth: '95%', maxRows: 3 },
            { _text: '主要产品/服务项目及其营业额<br>Main products / services and their annual turnover', name: '主要产品服务项目及其营业额', minWidth: '95%', maxRows: 3 },
            { _text: '曾用名/<br>Name used before', name: '曾用名', minWidth: '95%', maxRows: 3 },
            { _files: '附件', minWidth: '95%' },
        ]
    }

    fieldset联系人 = () => {
        const { list } = getListItems(this, '联系人', '联系人')
        return [
            {
                _grid: '', name: '联系人', rowNumbers: true, maxRows: 5, minRows: 5,
                columns: [
                    { _text: '姓名<br>Name', name: '姓名', minWidth: 150, },
                    { _text: '联系电话<br>Contact number', name: '联系电话', minWidth: 150, },
                    { _text: '邮箱<br>Mailbox', name: '邮箱', minWidth: 150, flex: 1, },
                ],
                buttons: [
                    { _button: '添加联系人...<br>Add Contacts', icon: 'plus', handler: this.handlerAddContact }
                ],
                onDoubleTap: data => {
                    Tyan.pubForm.showDialog('联系人', props => <SupplierContactWrite {...props} initValues基本信息={{ ...data }}
                        onConfirm={(changedValues, typesOfchangedValues, onClose) => {
                            let { 姓名 } = changedValues
                            if (姓名) {
                                姓名 = 姓名.replace(/(^\s*)|(\s*$)/g, "")
                                if (姓名 == '') {
                                    Tyan.pubForm.showError('联系人姓名不为空，请确认！')
                                    return
                                }
                                if (list.filter(o => o.id !== data.id && 姓名 == o.姓名).length) {
                                    Tyan.pubForm.showError('联系人姓名重复，请确认！')
                                    return
                                }
                                changeListItem(this, changedValues, typesOfchangedValues, '联系人', '联系人', data.id)
                                onClose && onClose()
                            }
                        }}
                        onDelete={() => deleteListItem(this, '联系人', '联系人', data.id)}
                    />)
                },
            }]
    }

    fieldset主要客户 = () => {
        const { list } = getListItems(this, '主要客户', '主要客户')
        return [
            {
                _grid: '', name: '主要客户', rowNumbers: true, minRows: 5, maxRows: 5,
                columns: [
                    { _text: '公司名称<br>Company Name', name: '公司名称', minWidth: 150, flex: 1, align: 'left' },
                    { _text: '年度<br>Year', name: '年度', minWidth: 150, flex: 1, },
                    { _text: '年营业额<br>Annual sales', name: '年营业额', minWidth: 150, flex: 1, },
                ],
                buttons: [
                    { _button: '添加主要客户...<br>Add primary customers', icon: 'plus', handler: this.handlerAddMainCustomer }
                ],
                onDoubleTap: data => {
                    Tyan.pubForm.showDialog('主要客户', props => <SupplierMainCustomerWrite {...props} initValues基本信息={{ ...data }}
                        onConfirm={(changedValues, typesOfchangedValues, onClose) => {
                            let { 公司名称 = data.公司名称, 年度 = data.年度 } = changedValues
                            if (公司名称 && 年度) {
                                公司名称 = 公司名称.replace(/(^\s*)|(\s*$)/g, "")
                                if (公司名称 == '') {
                                    Tyan.pubForm.showError('主要客户公司名称不为空，请确认！')
                                    return
                                }
                                年度 = 年度.replace(/(^\s*)|(\s*$)/g, "")
                                if (年度 == '') {
                                    Tyan.pubForm.showError('年营业额年度不为空，请确认！')
                                    return
                                }
                                if (list.filter(o => o.id !== data.id && 公司名称 == o.公司名称 && 年度 == o.年度).length) {
                                    Tyan.pubForm.showError('主要客户公司名称与重复，请确认！')
                                    return
                                }
                                changeListItem(this, changedValues, typesOfchangedValues, '主要客户', '主要客户', data.id)
                                onClose && onClose()
                            }
                        }}
                        onDelete={() => deleteListItem(this, '主要客户', '主要客户', data.id)}
                    />)
                },
            }]
    }

    fieldset年营业额 = () => {
        const { list } = getListItems(this, '年营业额', '年营业额')
        return [
            {
                _grid: '', name: '年营业额', rowNumbers: true, minRows: 5, maxRows: 5,
                columns: [
                    { _text: '年份<br>Year', name: '年份', minWidth: 150, },
                    { _text: '营业额<br>Turnover', name: '营业额', minWidth: 150, flex: 1, },
                ],
                buttons: [
                    { _button: '添加年营业额...<br>Add annual turnover', icon: 'plus', handler: this.handlerAddYearTurnover },
                ],
                onDoubleTap: data => {
                    Tyan.pubForm.showDialog('年营业额', props => <SupplierYearTurnoverWrite {...props} initValues基本信息={{ ...data }}
                        onConfirm={(changedValues, typesOfchangedValues, onClose) => {
                            let { 年份 } = changedValues
                            if (年份) {
                                年份 = 年份.replace(/(^\s*)|(\s*$)/g, "")
                                if (年份 == '') {
                                    Tyan.pubForm.showError('年营业额年份不为空，请确认！')
                                    return
                                }
                                if (list.filter(o => o.id !== data.id && 年份 == o.年份).length) {
                                    Tyan.pubForm.showError('年营业额年份重复，请确认！')
                                    return
                                }
                                changeListItem(this, changedValues, typesOfchangedValues, '年营业额', '年营业额', data.id)
                                onClose && onClose()
                            }
                        }}
                        onDelete={() => deleteListItem(this, '年营业额', '年营业额', data.id)}
                    />)
                },
            }]
    }

    fieldset主要设备 = () => {
        return [
            {
                _grid: '', name: '主要设备', rowNumbers: true, minRows: 5, maxRows: 5,
                columns: [
                    { _text: '名称<br>Name', name: '名称', minWidth: 150, flex: 1, },
                    { _text: '品牌型号<br>Brand and model', name: '品牌型号', minWidth: 150, flex: 1, },
                    { _text: '购买时间<br>Purchase time', name: '购买时间', minWidth: 150, flex: 1, },
                    { _text: '制造商<br>Manufacturer', name: '制造商', minWidth: 150, flex: 1, },
                    { _text: '数量<br>Quantity', name: '数量', minWidth: 150, flex: 1, },
                    { _text: '使用工序<br>Use the process', name: '使用工序', minWidth: 150, flex: 1, },
                    { _text: '产能<br>Capacity', name: '产能', minWidth: 150, flex: 1, align: 'left' },
                ],
                buttons: [
                    { _button: '添加...<br>Add', icon: 'plus', handler: this.handlerAddMainInstrument }
                ],
                onDoubleTap: data => {
                    Tyan.pubForm.showDialog('主要生产/检测设备', props => <SupplierMainInstrumentWrite {...props} initValues基本信息={{ ...data }}
                        onConfirm={(changedValues, typesOfchangedValues, onClose) => {
                            changeListItem(this, changedValues, typesOfchangedValues, '主要设备', '主要设备', data.id)
                            onClose && onClose()
                        }}
                        onDelete={() => deleteListItem(this, '主要设备', '主要设备', data.id)}
                    />)
                },
            }]
    }

    render = () => {
        const { match: { params: { token } } } = this.props
        const { cancled = false, initValues基本信息 } = this.state
        return (!token || cancled) ? <Redirect to='/' /> :
            initValues基本信息 ?
                <Panel shadow layout="fit" {...panelProps}>
                    <Container layout={{ type: 'hbox', align: 'top', pack: "center" }} style={colors.card.grey} padding={Ext.os.is.Phone ? "20% 0 0 0" : "0 0 0 0"}>
                        <FormPanel shadow height="100%" >
                            <Spacer height="10" />
                            <Logo title="实验室信息管理系统4.0" />
                            <Spacer height="10" />
                            <Form data={this} maxWidth="1100" isDialog={true} shadow={false}
                                controls={[
                                    { _button: '填写完成', icon: 'share', handler: this.handleSubmit, disabled: !this.bChanged() },
                                    { _button: '取消', handler: this.closeWindows },
                                ]}
                                fieldsets={
                                    [
                                        {
                                            _fieldsets: [
                                                { title: '联系人', _fieldset: this.fieldset联系人(), },
                                                { title: '主要客户', _fieldset: this.fieldset主要客户(), },
                                                { title: '年营业额', _fieldset: this.fieldset年营业额(), },
                                                { title: '主要生产/检测设备', name: '主要设备', _fieldset: this.fieldset主要设备(), },
                                            ], height: 400, docked: 'bottom', margin: '0 5 0 5',
                                        },
                                        { title: '基本信息', name: '基本信息', _fieldset: this.fieldset供应商信息(), },
                                    ]}
                            />
                            <Spacer height="20" />
                        </FormPanel>
                    </Container>
                </Panel>
                : <Message text={'请稍等 ...'} />
    }
}


export default SupplierInformationWrite